export default "__VITE_ASSET__CBzu0wCY__"